import { Mark, mergeAttributes } from '@tiptap/core'

export const Small = Mark.create({
  name: 'small',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  parseHTML() {
    return [
      {
        tag: 'small',
      },
      {
        style: 'vertical-align',
        getAttrs(value) {
          // Don’t match this rule if the vertical align isn’t sub.
          if (value !== 'small') {
            return false
          }

          // If it falls through we’ll match, and this mark will be applied.
          return null
        },
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['small', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addCommands() {
    return {
      setSmall: () => ({ commands }) => {
        return commands.setMark(this.name)
      },
      toggleSmall: () => ({ commands }) => {
        return commands.toggleMark(this.name)
      },
      unsetSmall: () => ({ commands }) => {
        return commands.unsetMark(this.name)
      },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-,': () => this.editor.commands.toggleSmall(),
    }
  },
})